@if (gridType) {
    <div class="display-filters">
        <div class="is-flex content-filters mtr-16-32 mbr-16-32">
            @if (showGridViewSelector) {
                <div>
                    <display-filter-icon
                        class="display-filter-comp"
                        [gridType]="gridType"
                        [filtersOpen]="filtersOpen"
                        [viewGrid]="viewGrid"
                        [hideStudioView]="hideStudioView"
                        (displayFilterEmitter)="sendGridView($event)"
                    ></display-filter-icon>
                </div>
            }
            @if (showFilter) {
                <div class="category-tool-filter align-items-center" [class.ml-16]="showGridViewSelector">
                    <div class="text-l leading-1 ttu text-right is-flex blend-link text-nowrap cursor-pointer" (click)="openFilterPanel()">
                        {{ 'dev.category.filters' | translate }}
                        @if (totalFiltersCount) {
                            <span class="pl-4">({{ totalFiltersCount }})</span>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}
